import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';

@Component({
  tag: 'pnk-chips',
  styleUrl: 'pnk-chips.css',
})
export class PnkChips {
  @Prop({ mutable: true, reflect: true }) value: string = '';

  @Prop({ mutable: true, reflect: true }) checked: boolean = false;

  @Prop() disabled: boolean = false;

  @Event() changed!: EventEmitter<boolean>;

  handleChange() {
    this.checked = !this.checked;
    this.changed.emit(this.checked);
  }

  render() {
    return (
      <div>
        <button
          class={`pnk-bg-disabled-base  focus:pnk-outline-none pnk-rounded-2xl pnk-px-5 pnk-py-1.5 pnk-w-auto pnk-h-[30px] ${this.checked ? 'pnk-bg-accent pnk-text-white' : ''} ${
            this.disabled ? 'pnk-bg-disabled-base pnk-opacity-50' : 'hover:pnk-bg-primary-hover pnk-cursor-pointer hover:pnk-text-white'
          }`}
          onClick={() => this.handleChange()}
          disabled={this.disabled}
        >
          <h1 class="pnk-text-sm">{this.value}</h1>
        </button>
      </div>
    );
  }
}
